import * as React from "react";

export function StepperBackIcon(props: Readonly<React.SVGProps<SVGSVGElement>>) {
  return (
    <svg width={18} height={18} viewBox="0 0 40 40" fill="none" {...props}>
      <path d="M13.042 21.667L22.3753 31.0003L20.0003 33.3337L6.66699 20.0003L20.0003 6.66699L22.3753 9.00033L13.042 18.3337H33.3337V21.667H13.042Z" fill="#1B1C1D"/>
    </svg>
  );
}
